import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';

const axiosInstance: AxiosInstance = axios.create({
  baseURL: 'https://mgread-api.17xiudou.cn', // 基础路径
  timeout: 5000, // 超时时间
});

// 请求拦截器
axiosInstance.interceptors.request.use(
  (config) => {
// 可在此添加 Token 或其他请求头

    return config;
  },
  (error) => Promise.reject(error)
);

// 响应拦截器
axiosInstance.interceptors.response.use(
  (response: AxiosResponse) => response,
  (error) => {
    console.error('响应错误:', error);
    return Promise.reject(error);
  }
);

export default axiosInstance;
